import React from 'react'

import { connectRefinementList } from 'react-instantsearch-dom'

import _ from 'lodash'

import { Badge, Select } from 'antd'

import { useTheme } from 'common/hooks/use-theme'

const allCustomersItem = {
  label: 'All Customers',
}

const FilterCustomer = ({ items, currentRefinement, refine, searchForItems, style }) => {
  const theme = useTheme()

  const sortedArray = _.sortBy(items, 'label')

  return (
    <Select
      placeholder="All Customers"
      onChange={(value = []) => {
        if (value === allCustomersItem?.label) {
          refine([])
          return
        }

        refine(value)
      }}
      bordered={false}
      style={{ fontSize: 22, minWidth: 300, ...style }}
      value={currentRefinement?.length ? currentRefinement : [allCustomersItem?.label]}
      optionLabelProp="label"
      showArrow
      showSearch
      onSearch={searchForItems}
    >
      {[allCustomersItem, ...sortedArray].map((item) => {
        const label = item?.label
        return (
          <Select.Option key={item.label} value={item.label} label={label} style={{ minHeight: 35 }}>
            {label}
            <Badge
              count={item?.count}
              style={{ marginLeft: '10px', background: theme.colors['gray-7'], color: theme.colors.white }}
            />
          </Select.Option>
        )
      })}
    </Select>
  )
}

export default connectRefinementList(FilterCustomer)
